import { useHasPermissions } from './permissionUtil';

const CLOSE_CASE_PERMISSIONS = ['UPDATE.MATTERS.STATUS_FIELD.INP_COMP', 'UPDATE.MATTERS.STATUS_FIELD.ALL'];

export function useHasCloseCasePermission(): boolean {
    return useHasPermissions(CLOSE_CASE_PERMISSIONS);
}
